module.exports = __webpack_public_path__ + "static/media/cam-toggle-w64.e2aa8fb5.svg";